// constants.js
export const DEFAULT_CARD_LABEL = "Default card label";
export const UNDEFINED_LABEL = "undefined";
export const TRANSLATION_KEYS = {
  CONTRACT_OF_SERVICES: "MY_HR_CONTRACT_OF_SERVICES",
};
